import { map, take } from 'rxjs/operators';
import { CatalogSearchCriteriaState, CatalogSearchCriteriaStateModel } from './catalog-search-criteria.state';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import {
  ChangeSearchCriteriaByCatalogType,
  SearchCriteriaInitialStateByCatalogType,
  GetSavedSearchCriteriaByCatalogTypeFromStorage,
} from './catalog-search-criteria.actions';
import { CatalogSearchCriteria } from '../../../common/models/catalog.model';
import { CatalogSearchCriteriaType } from './constants/catalog-search-criteria-type.constant';

@Injectable({ providedIn: 'root' })
export class CatalogSearchCriteriaFacade {
  state$: Observable<CatalogSearchCriteriaStateModel> = this.store.select(CatalogSearchCriteriaState.getState);

  constructor(private store: Store) {}

  getSearchCriteriaByCatalogType(catalogType: CatalogSearchCriteriaType): Observable<CatalogSearchCriteria> {
    return this.store.select(CatalogSearchCriteriaState.getSearchCriteriaByCatalogType).pipe(
      map((pickFn: (type: CatalogSearchCriteriaType) => CatalogSearchCriteria) => pickFn(catalogType)),
      take(1),
    );
  }

  getSavedSearchCriteriaByCatalogType(catalogType: CatalogSearchCriteriaType): Observable<CatalogSearchCriteria> {
    this.store.dispatch(new GetSavedSearchCriteriaByCatalogTypeFromStorage(catalogType));

    return this.store.select(CatalogSearchCriteriaState.getSearchCriteriaByCatalogType).pipe(
      map((pickFn: (type: CatalogSearchCriteriaType) => CatalogSearchCriteria) => pickFn(catalogType)),
      take(1),
    );
  }

  changeSearchCriteriaByCatalogType(
    searchCriteria: Partial<CatalogSearchCriteria>,
    catalogSearchCriteriaType: CatalogSearchCriteriaType,
  ): void {
    this.store.dispatch(
      new ChangeSearchCriteriaByCatalogType({
        searchCriteria,
        catalogSearchCriteriaType,
      }),
    );
  }

  setInitialStateByType(type: CatalogSearchCriteriaType): void {
    this.store.dispatch(new SearchCriteriaInitialStateByCatalogType(type));
  }
}
